import { SubscriptionPlan, SubscriptionPlanName } from "@arelia-types/subscriptions";

export const displayPlanName = (plan: SubscriptionPlan, isFreePlan?: boolean) => {
  if (plan === SubscriptionPlanName.Free || plan === SubscriptionPlanName.Starter) {
    return `${plan} plan`;
  }

  let baseName = plan === SubscriptionPlanName.PremiumMyFans
    ? "Premium + My Fans"
    : plan + " plan";

  return isFreePlan ? `Free ${baseName}` : baseName;
};
